const WEB_VERSION = 'web_version';
export const webCheck = (packageVersion: string): boolean => {
  const savedVersion = localStorage.getItem(WEB_VERSION);
  if (!savedVersion) {
    localStorage.setItem(WEB_VERSION, packageVersion);
  }
  if (savedVersion !== packageVersion) {
    // 버전이 변경되었으므로 새 버전으로 업데이트하고 새로고침
    localStorage.setItem(WEB_VERSION, packageVersion);
    console.log(`webCheck`);
    console.log(savedVersion);
    console.log(packageVersion);
    return false;
  }
  return true;
};
